export default __webpack_public_path__ + "static/media/YarnMv.ccf3cae2.webp";